import React from 'react'
import { Priority, PRIORITY_COLORS } from '../types/operations.types'
import { Badge } from '../styled/Operations.styled'

interface PriorityBadgeProps {
  priority: Priority
}

export const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority }) => {
  return (
    <Badge bg={PRIORITY_COLORS[priority]}>
      {priority}
    </Badge>
  )
}
